(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-accordion"] && !Shopify.designMode) return;
  try {
    
const mql = window.matchMedia('(min-width: 750px)');
const $accordion = document.querySelector('.js-c-tabs-accordion');
const $titles = $accordion.querySelectorAll('.c-tab-title');

function closeTab($title) {
  $title.classList.remove('is-opened');
  const content = $title.nextElementSibling;
  content.classList.remove('is-opened');
  content.style.maxHeight = 0;
}

function openTab($title) {
  $title.classList.add('is-opened');
  const content = $title.nextElementSibling;
  content.classList.add('is-opened');
  content.style.maxHeight = content.scrollHeight + 'px';
}

function closeAllExcept(activeTitle) {
  $titles.forEach(title => {
    if (title !== activeTitle && title.classList.contains('is-opened')) {
      closeTab(title);
    }
  });
}

$titles.forEach($title => {
  $title.addEventListener('click', () => {
    const isOpened = $title.classList.contains('is-opened');

    if (mql.matches) {
      if (isOpened) {
        closeTab($title);
      } else {
        closeAllExcept($title);
        openTab($title);
      }
    } else {
      $title.classList.toggle('is-opened');
      const content = $title.nextElementSibling;
      content.classList.toggle('is-opened');
      content.style.maxHeight = content.classList.contains('is-opened') ? content.scrollHeight + 'px' : 0;
    }
  });
});

// Open first tab on desktop by default
if (mql.matches && $titles.length) {
  openTab($titles[0]);
}

// Resize handler to re-calculate heights
window.addEventListener('resize', () => {
  $titles.forEach(title => {
    const content = title.nextElementSibling;
    if (title.classList.contains('is-opened')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
